import { I18N } from 'aurelia-i18n';
import { EventAggregator } from 'aurelia-event-aggregator';
import { BindingSignaler } from 'aurelia-templating-resources';
import { autoinject, observable } from 'aurelia-framework';
import { applicationLogger } from "../logging/logger";
import * as Linq from "linq-es2015";
import { LocaleEvents } from "../events/locale-events";

@autoinject
export class LanguageSelector {

	private readonly i18N: I18N;
	private readonly bindingSignaler: BindingSignaler;
	private readonly eventAggregator: EventAggregator;
	private locales: any[];
	@observable selectedLocale: any;

	constructor(i18N: I18N, bindingSignaler: BindingSignaler, eventAggregator: EventAggregator) {
		this.i18N = i18N;
		this.bindingSignaler = bindingSignaler;
		this.eventAggregator = eventAggregator;
		this.configureLocales();
		this.selectedLocale = this.getLocale(this.i18N.getLocale());
		applicationLogger.debug("Locale " + this.selectedLocale);
	}

	getLocale(name: string) {
		var enumerable = Linq.AsEnumerable(this.locales);
		return enumerable.FirstOrDefault(locale => locale.name === name);
	}

	selectedLocaleChanged() {
		this.i18N.setLocale(this.selectedLocale.name);
		localStorage.setItem("user-language", this.selectedLocale.name);
		this.bindingSignaler.signal("i18n");
		this.bindingSignaler.signal("aurelia-translation-signal");
		this.eventAggregator.publish(LocaleEvents.localeChanged, this.selectedLocale.name);
	}

	configureLocales() {
		this.locales = [
			{ name: "en", language: "English" },
			{ name: "es", language: "Espa�ol" },
		]
	};
}

export class UpperValueConverter {
	toView(value) {
		if (value === "en") {
			value = "us";
		}
		if (value === "es") {
			value = "mx";
		}
		return value && value.toUpperCase();
	}
}